import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { stringify } from 'qs';
import { getUserDepartmentsByQuery } from '../../../actions/userProfile';
import {
  Select,
} from 'antd';
import {
  normalizeToArray,
  isEmptySelection,
  stringifyWithArrays,
} from './utils/multiSelectUtils';

const stringifyOptions = {
  format: 'RFC1738',
  addQueryPrefix: true,
  sort: (a, b) => (a.localeCompare(b)),
};

class AssigneeSearchSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUser: props.multiSelect
        ? normalizeToArray(props.paramTools.params.assignee)
        : props.paramTools.params.assignee,
    };
  }

  componentDidMount() {
    this.props.getUserDepartmentsByQuery('?page_size=10000');
  }

  updateQuery = async (user) => {
    const {
      paramTools,
      inboxActions,
      queryType,
      multiSelect,
    } = this.props;
    const { params } = paramTools;
    const { getRecords } = inboxActions;
    const normalized = multiSelect ? normalizeToArray(user) : user;
    this.setState({ selectedUser: normalized });
    if (multiSelect ? isEmptySelection(normalized) : (!user || user.trim() === '')) {
      delete params[queryType];
      params.page = 1;
    } else {
      params[queryType] = normalized;
      params.page = 1;
    }
    const query = multiSelect
      ? stringifyWithArrays(params)
      : stringify(params, stringifyOptions);
    await getRecords(query);
  }

  render() {
    const { selectedUser } = this.state;
    const { departmentUsers, multiSelect } = this.props;

    return (
      <div>
        <Select
          showSearch
          style={{ width: '220px', marginTop: 20 }}
          label="Assignee"
          placeholder="Search by Assignee"
          allowClear
          value={selectedUser}
          mode={multiSelect ? 'multiple' : undefined}
          onChange={option => this.updateQuery(option)}
          options={departmentUsers?.map(user => ({
            label: user[1],
            value: user[0],
          }))}
          filterOption={(input, option) =>
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        />
      </div>
    );
  }
}

AssigneeSearchSettings.propTypes = {
  inboxActions: PropTypes.object.isRequired,
  paramTools: PropTypes.object.isRequired,
  queryType: PropTypes.string,
  departmentUsers: PropTypes.array.isRequired,
  multiSelect: PropTypes.bool,
};

AssigneeSearchSettings.defaultProps = {
  queryType: 'assignee',
  multiSelect: false,
};

export default connect(state => ({
  departmentUsers: state.userProfile.departmentUsers,
}), { getUserDepartmentsByQuery })(AssigneeSearchSettings);
